import {Button, useRecordContext} from "react-admin";
import {getJwtHeader} from "../auth/authProvider";
import {apiUrl} from "../dataProvider";
import LoginOutlinedIcon from '@mui/icons-material/LoginOutlined';

export const ImpersonateButton = () => {
    const userRecord = useRecordContext();
    if (!userRecord) return null;

    const handleClick = async () => {
        const userKey = await fetchUserKey(userRecord.id.toString())
        if (userKey) {
            const redirectUrl = `https://testdvgugyfelszolgalat.dvgzrt.hu/super-user?token=${userKey}`

            window.open(redirectUrl, "_blank")
        }
        // need a commit
    };

    return (
        <Button
            label="Bejelentkezés"
            startIcon={<LoginOutlinedIcon/>}
            onClick={handleClick}
            variant={"contained"}
            sx={{marginBottom: '10px'}}
        />
    );
};

async function fetchUserKey(webUserId: string): Promise<string> {
    const response = await fetch(`${apiUrl}/impersonate/${webUserId}`, {
        method: "POST",
        headers: {
            "Authorization": getJwtHeader(),
            "Content-Type": "application/json"
        }
    });

    if (!response.ok) {
        throw new Error("Hiba történt.")
    }

    const data = await response.json();
    return data.userKey;
}
